<template>
  <div>
    <Modal
      class="addDataSource"
      width="500"
      v-model="currentDataStatus"
      :closable="false"
      :mask-closable="false"
      :footer-hide="true"
    >
    <!-- 上面提示文字 -->
    <div class="tip-header">
      <span>数据源{{ titleLayer }}</span>
      <span class="iconfont ys-iconguanbi" @click="handleReset('formValidate')"></span>
    </div>
    <!-- form表单 -->
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
      <FormItem prop="soc_name" style="margin-right: 18px;width: 100%;">
        <Input class="ys_input_border_bottom" v-model="formValidate.soc_name" placeholder="请输入数据源名称" />
      </FormItem>
      <FormItem style="width: 100%;" prop="remote_uname">
        <Input class="ys_input_border_bottom" v-model="formValidate.remote_uname" placeholder="请输入主机用户名" />
      </FormItem>
      <FormItem style="width: 100%;" prop="remote_passwd">
        <Input class="ys_input_border_bottom" v-model="formValidate.remote_passwd" type="password" placeholder="请输入主机密码" />
      </FormItem>
      <FormItem style="width: 100%;" prop="soc_ip">
        <Input class="ys_input_border_bottom" v-model="formValidate.soc_ip" placeholder="请输入IP地址" />
      </FormItem>
      <FormItem style="width: 100%;" prop="soc_port">
        <Input class="ys_input_border_bottom" v-model="formValidate.soc_port" placeholder="请输入端口号" minlength="4"/>
      </FormItem>
      <FormItem style="width: 100%;" prop="user_root_path">
        <Input class="ys_input_border_bottom" v-model="formValidate.user_root_path" placeholder="请输入用户根路径" />
      </FormItem>
      <FormItem style="width: 100%;" prop="soc_domain">
        <Input class="ys_input_border_bottom" v-model="formValidate.soc_domain" placeholder="请输入域名" />
      </FormItem>
      <FormItem style="width: 100%;" prop="bk_timeout">
        <Input class="ys_input_border_bottom" v-model="formValidate.bk_timeout" placeholder="请输入超时时间(s)" @on-change="handleTimeout" />
      </FormItem>
      <FormItem style="width: 100%;" prop="environment_variables">
        <Input class="ys_input_border_bottom" v-model="formValidate.environment_variables" placeholder="请输入环境变量" />
      </FormItem>
      <FormItem style="width: 100%;" prop="encoding_type">
        <Input class="ys_input_border_bottom" v-model="formValidate.encoding_type" placeholder="请输入编码格式" />
      </FormItem>
      <FormItem prop="cvt_type" style="margin-right: 14px;width: 100%;">
        <Select v-model="formValidate.cvt_type" placeholder="请选择转码方式">
          <Option v-for="(item, index) in wayData" :value="item.ivalue" :key="index">{{ item.cname }}</Option>
        </Select>
      </FormItem>
      <FormItem prop="protocol_type" style="margin-right: 14px;width: 100%;">
        <Select v-model="formValidate.protocol_type" placeholder="请选择协议类型" @on-change="handleTypeChange">
          <Option v-for="(item, index) in typeData" :value="item.ivalue" :key="index">{{ item.cname }}</Option>
        </Select>
      </FormItem>
      <!-- 第一种情况 -->
      <div class="protocolParameters" v-if="changeCode === 1">
        <FormItem style="width: 100%;" prop="jdbc_drv">
          <Input class="ys_input_border_bottom" v-model="formValidate.jdbc_drv" placeholder="请输入Jdbc_driver" />
        </FormItem>
        <FormItem style="width: 100%;" prop="jdbc_url">
          <Input class="ys_input_border_bottom" v-model="formValidate.jdbc_url" placeholder="请输入Jdbc_url" />
        </FormItem>
        <FormItem style="width: 100%;" prop="jdbc_schema">
          <Input class="ys_input_border_bottom" v-model="formValidate.jdbc_schema" placeholder="请输入Jdbc_schema" />
        </FormItem>
      </div>
      <div class="protocolParameters" v-if="changeCode === 2">
        <FormItem prop="transfer_protocol">
          <RadioGroup v-model="formValidate.transfer_protocol">
            <Radio label="SVN">SVN</Radio>
            <Radio label="HTTP">HTTP</Radio>
          </RadioGroup>
        </FormItem>
      </div>
      <FormItem prop="soc_bk_desc">
        <Input type="textarea" style="width: 100%;" v-model="formValidate.soc_bk_desc" placeholder="请输入描述" :autosize="{minRows: 5,maxRows: 8}" />
      </FormItem>
    </Form>
    <!-- 按钮组 -->
    <div class="btn-box">
      <Button  class="ys-cancel" @click="handleReset('formValidate')" style="width: 100px; margin-right: 20px">取消</Button>
      <Button class="ys-confirm" type="primary" @click="handleSubmit('formValidate')" style="width: 100px;">确认</Button>
    </div>
  </Modal>
  </div>
</template>
<script>
import { 
  mapActions
} from "vuex";
export default {
  props: {
    currentDataStatus:{
      type: Boolean,
      defalut: false
    },
    titleLayer: {
      type: String,
      default: '新建'
    },
    editId: {
      type: String,
      default: ''
    },
    transmitSocName: {
      type: String,
      defalut: ''
    }
  },
  data() {
    return {
      formValidate: {
        soc_name: '', // 数据源名称
        remote_uname: '', // 主机用户名
        remote_passwd: '', // 主机密码
        soc_ip: '', // IP地址
        soc_port: '', // 端口号
        user_root_path: '', // 用户根路径
        soc_domain: '', // 域名
        bk_timeout: '', // 超时时间
        environment_variables: '', // 环境变量
        encoding_type: '', // 编码格式
        cvt_type: '', // 转码方式
        protocol_type: '', // 协议类型
        soc_bk_desc: '', // 描述
        
        key_remote_passwd: 'test',
        jdbc_drv: '',
        jdbc_url: '',
        jdbc_schema: '',
        ftp_local_script: 'test',
        cvt_local_script: 'test',
        transfer_protocol: ''
      },
      ruleValidate: {
        soc_name: [
          { required: true, message: '请输入数据源名称', trigger: 'blur' }
        ],
        remote_uname: [
          { required: true, message: '请输入主机用户名', trigger: 'blur' }
        ],
        remote_passwd: [
          { required: true, message: '请输入主机密码', trigger: 'blur' }
        ],
        soc_ip: [
          { required: true, message: '请输入IP地址', trigger: 'blur' }
        ],
        soc_port: [
          { required: true, message: '请输入端口号', trigger: 'blur'  },
          { pattern: /^\+?[1-9][0-9]*$/, message: "端口为非零开头的数字", trigger: "blur" }
        ],
        user_root_path: [
          { required: true, message: '请输入用户根路径', trigger: 'blur' }
        ],
        soc_domain: [
          { required: true, message: '请输入域名', trigger: 'blur' }
        ],
        bk_timeout: [
          { required: true, message: '请输入超时时间', type: 'number', trigger: 'blur' },
          { pattern: /^(0|[1-9][0-9]*)$/, message: "时间请输入纯数字", trigger: "blur" }
        ],
        environment_variables: [
          { required: true, message: '请输入环境变量', trigger: 'blur' }
        ],
        encoding_type: [
          { required: true, message: '请输入编码格式', trigger: 'blur' }
        ],
        cvt_type: [
          { required: true, message: '请选择转码方式', type: 'number', trigger: 'change' }
        ],
        protocol_type: [
          { required: true, message: '请选择协议类型', type: 'number', trigger: 'change' }
        ],
        soc_bk_desc: [
          { required: true, message: '请输入描述', trigger: 'blur' }
        ],
        jdbc_drv: [
          { required: true, message: '请输入Jdbc_driver', trigger: 'blur' }
        ],
        jdbc_url: [
          { required: true, message: '请输入Jdbc_url', trigger: 'blur' }
        ],
        jdbc_schema: [
          { required: true, message: '请输入Jdbc_schema', trigger: 'blur' }
        ],
        transfer_protocol: [
          { required: true, message: '请选择传输协议', trigger: 'change' }
        ],
      },
      wayData: null, // 编码方式
      typeData: null, // 协议类型
      changeCode: -1
    }
  },
  methods: {
    ...mapActions([
      'viewEnumActionAll', // 获取枚举类
      'updateSocActionData', // 编辑保存
      'addStorage', // 新建保存
      'editSocBySocNameAction', // 编辑回显
    ]),
    // 超时时间输入处理成number类型
    handleTimeout() {
      this.formValidate.bk_timeout = this.formValidate.bk_timeout * 1;
    },
    // 确认
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.titleLayer === '新建' ? this.addStorages() : this.updateResources();
        } else {
          this.$Message.error('请完善信息！');
        }
      })
    },
    // 取消
    handleReset(name) {
      this.$refs[name].resetFields();
      this.$emit('on-jurisdiction-click', 2);
    },
    // 选择了协议类型
    handleTypeChange() {
      switch (this.formValidate.protocol_type) {
        case 1:
          this.changeCode = 1;
          break;
        case 13:
          this.changeCode = 2;
          break;
        default:
          this.changeCode = -1;
          break;
      }
    },
    // 获取枚举类
    async viewEnumActionAlls(options) {
      try {
        const data = await this.viewEnumActionAll({class_name: options});
        if (data.request_state) {
          options === 'ys.manufacture.framework.enu.CVT_TYPE' ? this.wayData = data.enum_list : this.typeData = data.enum_list;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 新建保存
    async addStorages() {
      try {
        const data = await this.addStorage(this.formValidate);
        if (data.request_state) {
          this.$Message.success('新建成功！');
          this.$emit('on-jurisdiction-click', 2);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 编辑保存
    async updateResources() {
      try {
        const data = await this.updateSocActionData(this.formValidate);
        if (data.request_state) {
          this.$Message.success('编辑成功！');
          this.$emit('on-jurisdiction-click', 2);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 编辑回显
    async editSocBySocNameActions() {
      try {
        const data = await this.editSocBySocNameAction({soc_name: this.transmitSocName});
        if (data.request_state) {
          let ev = {
            ...data,
            soc_port: data.soc_port + ''
          };
          delete ev.request_state;
          this.formValidate = ev;
          switch (data.protocol_type) {
            case 1:
              this.changeCode = 1;
              break;
            case 13:
              this.changeCode = 2;
              break;
            default:
              this.changeCode = -1;
              break;
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  mounted() {
    // 获取编码方式
    this.viewEnumActionAlls('ys.manufacture.framework.enu.CVT_TYPE');
    // 获取协议类型
    this.viewEnumActionAlls('ys.manufacture.framework.enu.PROTOCOL_TYPE');
    if (this.titleLayer === '编辑') {
      // 编辑回显
      this.editSocBySocNameActions();
    }
  },
}
</script>
<style lang="less" scoped>
.addDataSource {
  .tip-header {
    width: 100%;
    height: 30px;
    line-height: 30px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin-bottom: 24px;
    span:nth-of-type(1) {
      font-size:18px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(179,195,226,1);
    }
    span:nth-of-type(2) {
      font-size: 28px;
    }
    span:nth-of-type(2):hover {
      cursor: pointer;
    }
  }
  .btn-box {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
    margin-top: 40px;
  }
  .protocolParameters {
    width: 100%;
    margin-bottom: 20px;
  }
}
</style>
